import { useEffect, useState } from "react";
import { Card, Box, Typography, Button, Divider } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { getTaxDetailsRequest } from "../../../../../redux/inspection-firms/slice";
import { useDispatch, useSelector } from "react-redux";
import EditTaxDetails from "./edit-tax-details/edit-tax-details";
import Loading from "../../../../../components/loading/loading";

type props = {
  data: any;
};

export default function TaxDetails({ data }: props) {
  const dispatch = useDispatch();
  const [showEditTax, setShowEditTax] = useState(false);

  useEffect(() => {
    dispatch(getTaxDetailsRequest({ id: data?.id }));
  }, [data, dispatch]);

  const { loading, taxDetails } = useSelector(
    (state: any) => state.inspectionFirms
  );

  const handleEditTax = () => {
    setShowEditTax(true);
  };

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Tax</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditTax}
          >
            Edit
          </Button>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Name of Entity/Individual
          </Typography>
          <Typography>{taxDetails?.entityName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Business Name/DBA (if different from above)
          </Typography>
          <Typography>{taxDetails?.businessName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Tax Classification</Typography>
          <Typography>{taxDetails?.taxClassificationName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Tax ID Number</Typography>
          <Typography>{taxDetails?.taxIdNumber}</Typography>
        </Box>
      </Card>
      {loading && <Loading />}
      {showEditTax && (
        <EditTaxDetails
          showDialog={showEditTax}
          closeDialog={() => setShowEditTax(false)}
          data={{ ...taxDetails, id: data?.id }}
        />
      )}
    </>
  );
}
